import React from "react";
import Link from "gatsby-link";

import fb from "../layouts/img/fb.svg";
import twitter from "../layouts/img/twitter.svg";
// import linkedin from "../layouts/img/linked.png";
import instagram from "../layouts/img/instagram.svg";

const Footer = () => (
  <footer id="colophon" className="site-footer landing-footer">
    <div className="container">
      <ul className="list-unstyled list-inline">
        <li>
          <a href="https://www.facebook.com/swissmonkeyinc/" target="_blank">
            <img src={fb} alt="" />
          </a>
        </li>
        <li>
          <a href="https://twitter.com/swissmonkeyinc" target="_blank">
            <img src={twitter} alt="" />
          </a>
        </li>
        {/*<li>*/}
        {/*<a href="https://www.linkedin.com/company/swiss-monkey-inc?trk=company_logo">*/}
        {/*<img src={linkedin} alt="" />*/}
        {/*</a>*/}
        {/*</li>*/}
        <li>
          <a href="https://www.instagram.com/swissmonkeyinc/" target="_blank">
            <img src={instagram} alt="" />
          </a>
        </li>
      </ul>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          flexWrap: "wrap",
          justifyContent: "center",
          marginTop: "4rem"
        }}
      >
        <a
          href="mailto:contact@swissmonkey.io"
          style={{ color: "#7d287d", fontWeight: "500" }}
        >
          contact@swissmonkey.io
        </a>
        <span style={{ margin: "0 1rem" }}>|</span>
        <a
          href="tel:+19165004125"
          style={{ color: "#7d287d", fontWeight: "500" }}
        >
          (916) 500-4125{" "}
        </a>
      </div>

      <p className="copyright">© 2018 SWISS MONKEY. ALL RIGHTS RESERVED.</p>

      <Link to="/terms" className="purple-link">
        Terms and Services
      </Link>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js